<template>
    <div class="container base-height" v-e2e="'formulario-tarefa-sucesso-page'">
        <div class="columns base-height">
            <div class="column is-half base-height py-0">
                <div class="is-flex is-flex-direction-column base-height">
                    <div style="max-width:calc(100vw / 4);min-width: 320px;">
                        <img :src="logoSrc" alt="logo" />
                    </div>
                    <div class="box-texto is-flex is-flex-direction-column is-justify-content-center is-flex-grow-1" style="margin-top:-4rem">
                        <div v-e2e="'formulario-tarefa-sucesso-titulo'">
                            <h1 class="is-size-3">Formulário enviado com sucesso!</h1>
                        </div>
                        <hr class="mt-3 mb-4" />
                        <br/>
                        <div v-e2e="'formulario-tarefa-sucesso-mensagem'">
                            <p>Sua resposta foi salva e enviada com sucesso. Em caso de dúvidas, entre em contato com o responsável pelo recebimento das informações.</p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="column is-half py-0">
                <div class="is-flex base-height is-justify-content-center is-align-items-center">
                    <img src="/img/form_success.png" alt="logo" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "TrfFormEnviado",
    computed: {
        logoSrc() {
            return getComputedStyle(document.documentElement).getPropertyValue('--logoUrl').trim();
        }
    }
}
</script>

<style scoped>
    .base-height {
        min-height: calc(100vh - 128px)
    }
    @media screen and (max-width: 768px) {
        .container {
            padding: 0 1rem;
        }
        .base-height {
            min-height: auto;
        }
        .box-texto {
            margin-top: 0!important
        } 
    }
</style>